var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_68",
    "data-name": "Rect\\xE1ngulo 68",
    width: 21.165,
    height: 21.723,
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_google",
    transform: "translate(19065.5 -7747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_8",
    "data-name": "Elipse 8",
    transform: "translate(-19065.5 7747)",
    fill: "#efefed",
    stroke: "#1c1c1c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_128",
    "data-name": "Grupo 128",
    transform: "translate(-19053.5 7759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_127",
    "data-name": "Grupo 127",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44",
    "data-name": "Trazado 44",
    d: "M11.016,12.912V9.944h10a9.814,9.814,0,0,1,.148,1.792,9.8,9.8,0,0,1-2.57,6.941,9.933,9.933,0,0,1-7.576,3.047A11.014,11.014,0,0,1,0,10.862,11.014,11.014,0,0,1,11.019,0a10.351,10.351,0,0,1,7.443,2.993L16.368,5.087a7.565,7.565,0,0,0-5.352-2.119,7.792,7.792,0,0,0-7.79,7.894,7.792,7.792,0,0,0,7.79,7.894A7.263,7.263,0,0,0,16.5,16.583a6.153,6.153,0,0,0,1.609-3.674Z",
    fill: "#1c1c1c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/_google.7a7b688f6cb64a9019462c649ae2edee.svg";
export { ForwardRef as ReactComponent };